import { DatePipe } from '@angular/common';
import moment from 'moment';

export enum EventSource {
  EVENTBRITE = 'EVENTBRITE',
  CAMPUSLABS = 'CAMPUSLABS',
  AEM = 'AEM',
}

export class Event {
  eventId: string;
  eventSource: EventSource;
  name: string;
  startDateTime: string;
  endDateTime: string;
  summary: string;
  description: string;
  imageUrl: string;
  thumbnailUrl: string;
  location: EventLocation;
  isFree: boolean;
  lowestPrice: number;
  highestPrice: number;
  isSoldOut: boolean;
  organiserUrl: string;
  organisationName: string;
  categoryName: string;
  subcategoryName: string;

  private datePipe: DatePipe;

  constructor(event: Event) {
    for (let prop in event) {
      this[prop] = event[prop];
    }
    this.datePipe = new DatePipe('en-NZ');
  }

  getEventStartTimeDisplay(): string {
    return this.startDateTime ? moment(this.startDateTime).format('dddd, MMM D YYYY, h:mma') : '-';
  }

  getLocationDisplay(): string {
    return this.location ? this.location.name : '-';
  }

  getPriceDisplay(): string {
    return this.isFree
      ? 'Free'
      : this.lowestPrice == this.highestPrice
      ? '$' + this.lowestPrice
      : '$' + this.lowestPrice + ' - ' + '$' + this.highestPrice;
  }
}

export class EventLocation {
  name: string;
  address1: string;
  address2: string;
  city: string;
  region: string;
  postCode: string;
  country: string;
  latitude: string;
  longitude: string;
  displayName: string;
}
